import { Grid } from "@mui/material";
import { FormikProps, useFormikContext } from "formik";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { Data, Processor } from "../../../store/merchant/types";
import pageStyles from "./../../../pages/pageStyles";
import MerchantAdditionalDataForm from "./MerchantAdditionalDataForm";
import SelectDropDown from "../../../common/formElements/SelectDropDown";
import TextInput from "../../../common/formElements/TextInput";

interface MerchantProcessorForm {
  index: number;
  processor: Processor;
  disabled?: boolean;
}

const MerchantProcessorForm = (props: MerchantProcessorForm) => {
  const { index, processor, disabled } = props;
  const formProps = useFormikContext();
  const { values } = formProps as FormikProps<Data>;
  const classes = pageStyles();

  const processors = useSelector(
    (state: ApplicationState) => state.processor.data
  );

  const processorOptions =
    (processors &&
      processors.data &&
      processors.data
        .filter((dropDownOption) => {
          const selectedValue =
            values?.attributes?.Processor &&
            values.attributes.Processor[index].ProcessorName;
          return (
            values?.attributes?.Processor?.map(
              (processor: Processor) => processor.ProcessorName
            ).indexOf(dropDownOption.attributes.Name) === -1 ||
            dropDownOption.attributes.Name === selectedValue
          );
        })
        .map((p) => p.attributes.Name)) ||
    [];

  return (
    <Grid container alignItems="flex-start" spacing={2}>
      <Grid item xs={12} md={6}>
        {processorOptions.length ? (
          <SelectDropDown
            fieldname={`attributes.Processor[${index}].ProcessorName`}
            label="Name"
            options={processorOptions}
            disabled={disabled}
          />
        ) : null}
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          fieldname={`attributes.Processor[${index}].MID`}
          label="MID"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <hr className={classes.devide} />
        <MerchantAdditionalDataForm
          disabled={disabled}
          index={index}
          processor={processor}
        />
      </Grid>
    </Grid>
  );
};

export default memo(MerchantProcessorForm);
